import React from "react";

const statusConfig = (s) => {
  if (!s) return { bg: "#f3f4f6", text: "#6b7280", border: "#d1d5db" };
  if (s === "succeeded" || s === "completed" || s === "success")
    return { bg: "var(--badge-success-bg)", text: "var(--success)", border: "var(--success)" };
  if (s === "duplicate")
    return { bg: "var(--badge-warn-bg)", text: "var(--warning)", border: "var(--warning)" };
  if (s === "rejected")
    return { bg: "#fef2f2", text: "#991b1b", border: "#dc2626" };
  if (s === "need_review" || s === "partial_success" || s.includes("error"))
    return { bg: "#fff7ed", text: "#c2410c", border: "#f97316" };
  if (s === "running")
    return { bg: "#dbeafe", text: "#1e40af", border: "#3b82f6" };
  if (s === "expired")
    return { bg: "#f3e8ff", text: "#6b21a8", border: "#a855f7" };
  if (s === "failed" || s === "compensated")
    return { bg: "var(--badge-fail-bg)", text: "var(--danger)", border: "var(--danger)" };
  return { bg: "#f3f4f6", text: "#6b7280", border: "#d1d5db" };
};

const statusLabel = (s) => {
  if (s === "success" || s === "succeeded" || s === "completed") return "OK";
  if (s === "rejected") return "Rejected";
  if (s === "need_review") return "Need Review";
  if (s === "failed" || s === "compensated") return "Need Review";
  if (s === "duplicate") return "Duplicate";
  if (s === "expired") return "Expired";
  if (s === "running") return "Running";
  if (s === "partial_success") return "Partial";
  return s || "—";
};

function StatsTable({ data, onSelect, activeId, sentinelRef, hasMore, loadingMore }) {
  if (!data?.length) return <p className="info">No recent results.</p>;

  return (
    <div className="st-list">
      {data.map((r, i) => {
        const config = statusConfig(r.status);
        const quoteIds = r.quote_ids || [];
        const missingFields = r.missing_fields || [];
        const isDup = r.quote_type === "Duplicate" || r.is_clone;
        const isActive = activeId && r.message_id === activeId;

        return (
          <div
            key={r._id || i}
            className={`st-card${isActive ? " st-card-active" : ""}`}
            style={{ borderLeftColor: config.border }}
            onClick={() => onSelect(r.message_id)}
          >
            {/* Header row: subject + badges */}
            <div className="st-card-header">
              <span className="st-card-subject">
                {r.mail_subject || <span style={{ color: "var(--text-dimmed)", fontStyle: "italic" }}>No subject</span>}
              </span>
              <div className="st-card-badges">
                {(r.quote_type !== undefined || r.is_clone !== undefined) && (
                  <span className={`st-card-type ${isDup ? "st-type-dup" : "st-type-new"}`}>
                    {r.quote_type || (r.is_clone ? "Duplicate" : "New Quote")}
                  </span>
                )}
                <span className="st-card-badge" style={{ background: config.bg, color: config.text }}>
                  {statusLabel(r.status)}
                </span>
              </div>
            </div>

            {/* Quote IDs row */}
            {quoteIds.length > 0 && (
              <div className="st-card-quotes">
                {quoteIds.map((q, qi) => (
                  <span key={qi} className="st-quote-chip">
                    #{q.quote_id} <span className="st-quote-lob">LOB:{q.application_type_id}</span>
                  </span>
                ))}
              </div>
            )}
            {!quoteIds.length && r.quote_id && (
              <div className="st-card-quotes">
                <span className="st-quote-chip">{r.quote_id}</span>
              </div>
            )}

            {/* Duplicate ref */}
            {r.duplicate_quote_id && (
              <div className="st-card-dup-ref">
                🔗 Original Quote: <strong>#{r.duplicate_quote_id}</strong>
              </div>
            )}

            {/* Meta row: step + timestamps */}
            <div className="st-card-meta">
              <span>Step: <strong>{r.step || "—"}</strong></span>
              <span style={{ display: "flex", gap: "10px" }}>
                {r.created_at && (
                  <span>Created: {new Date(r.created_at).toLocaleString()}</span>
                )}
                {r.updated_at && (
                  <span>Updated: {new Date(r.updated_at).toLocaleString()}</span>
                )}
              </span>
            </div>

            {/* Missing fields */}
            {missingFields.length > 0 && (
              <div className="st-card-missing">
                ⚠ Missing: {missingFields.map((f, fi) => (
                  <span key={fi} className="st-missing-chip">{f}</span>
                ))}
              </div>
            )}

            {/* Error */}
            {r.error && <div className="st-card-error">✕ {r.error}</div>}
          </div>
        );
      })}

      {/* Infinite scroll sentinel */}
      {sentinelRef && (
        <div ref={sentinelRef} style={{ height: 1 }} />
      )}
      {loadingMore && (
        <div className="st-load-more">
          <span className="st-spinner" /> Loading more...
        </div>
      )}
      {!hasMore && data.length > 0 && !loadingMore && sentinelRef && (
        <div className="st-end-msg">All {data.length} records loaded</div>
      )}
    </div>
  );
}

export default StatsTable;
